import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import mujerVideo from "../../assets/bg/mujer-manuel.webm";
import mujerVideoMp4 from "../../assets/bg/mujer-manuel.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario2Mujer({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
    
    const { videoRef, canPlayWithSound } = useVideoWithSound({ 
        autoPlay: true, 
        volume: 0.8
    });

    const [canGoNext, setCanGoNext] = useState(false);

	const activeScenario = getScenarioNumByPath(location.pathname);
        
    useEffect(() => {
        const timer = setTimeout(() => setCanGoNext(true), 20000);
        return () => clearTimeout(timer);
    }, []);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0">
            <div className="row h-100 m-0">
            <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                {/* VIDEO DE FONDO */}
                <video
                ref={videoRef}
                className="bg-video-manuel"
                autoPlay
                playsInline
                preload="auto"
                muted={!canPlayWithSound}
                onEnded={() => setCanGoNext(true)}
                onError={() => setCanGoNext(true)}
                >
                    <source src={mujerVideoMp4}  type="video/mp4" />
                    <source src={mujerVideo} type="video/webm" />
                </video>

                {/* CAPA DE CONTENIDO POR ENCIMA */}
                <div className="content-overlay d-flex flex-column justify-content-end align-items-center h-75 px-5 position-relative mt-5">
                <img
                    src={oncommit}
                    alt="decorativo"
                    style={{ maxWidth: "187px", top: "-30px", left: "20px" }}
                    className="position-absolute"
                />
                <div className="recuadro recuadro-orange txtTexto1 w-50">
                    <p>
                    Doctor, ¿qué significa que sea de alto riesgo? ¿Mi esposo tiene poco tiempo de vida? Necesitamos que nos lo diga claro.
                    </p>
                </div>
                <div className="mt-3 d-flex align-items-center w-100 justify-content-end">
                    <NextButton
                    navigateTo={ROUTES.SCENARIO2_FIN}
                    activeScenario={activeScenario}
                    color="orange"
                    canGoNext={canGoNext}
                    />
                </div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario2Mujer);
